async function getParts(url, partName) {
  let options = {}
  const { timeout = 300000 } = options;
  
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  //Prepare options for fetch
  const requestConfig = {
    method: "GET",
    ...options,
    signal: controller.signal
  };


  //https://hashnode.com/post/javascript-fetch-retry-upon-failure-cjf0654cj001gmps1o754n9xc
  const fetch_retry = async (url, requestConfig, n) => {
    try {
      
      return await fetch(url, requestConfig)
        .then((response) => response.json())
        .then((data) => {
          return data;
        });
    } catch (error) {
      if (n === 1) return { error: error };
      return await fetch_retry(url, requestConfig, n - 1);
    }
  };

  if (partName) {
    const partNameEncoded = encodeURIComponent(partName)
    url = url + '?part=' + partNameEncoded
  }
  console.log(url)
  return fetch_retry(url, requestConfig, 3);
}

export default getParts;
